<script setup lang="ts">
/**
 * 공통 Transfer 반복표 ([[if transfers]] … [[/if transfers]] 재현) — ctx 로 행 추가/삭제.
 * DCR · Waiver 두 문서가 같은 tr{n}_* 키를 공유하므로 한 문서에서 채우면 다른 문서 표에 즉시 반영.
 */
import { inject, computed } from 'vue';
import { TRANSFER_DOC_CTX } from '../transferContext';
import TransferDocVarField from '../TransferDocVarField.vue';

const ctx = inject(TRANSFER_DOC_CTX)!;
const rows = computed(() => Array.from({ length: ctx.transferCount.value }, (_, i) => i + 1));
</script>

<template>
  <table class="cdd-tbl trf-tbl">
    <tbody>
      <tr class="cdd-sec">
        <th>Name of Transferor</th>
        <th>Certificate Number</th>
        <th>No. of Shares</th>
        <th>Name of Transferee</th>
        <th>New Certificate Number</th>
        <th>New No. of Shares</th>
        <th style="width:36px"></th>
      </tr>
      <tr v-for="n in rows" :key="n">
        <td><TransferDocVarField :field-key="`tr${n}_transferor_name`" :placeholder="`Transferor ${n}`" /></td>
        <td><TransferDocVarField :field-key="`tr${n}_certificate_no`" placeholder="Cert No." /></td>
        <td><TransferDocVarField :field-key="`tr${n}_shares`" placeholder="Shares" /></td>
        <td><TransferDocVarField :field-key="`tr${n}_transferee_name`" :placeholder="`Transferee ${n}`" /></td>
        <td><TransferDocVarField :field-key="`tr${n}_new_certificate_no`" placeholder="New Cert No." /></td>
        <td><TransferDocVarField :field-key="`tr${n}_new_shares`" placeholder="New Shares" /></td>
        <td>
          <button v-if="ctx.transferCount.value > 1" class="trf-rowbtn" title="Remove" @click="ctx.removeTransfer(n)">✕</button>
        </td>
      </tr>
      <tr>
        <td colspan="7"><button class="trf-addrow" @click="ctx.addTransfer()">+ Add transfer</button></td>
      </tr>
      <tr>
        <td colspan="5" style="text-align:right"><b>Total Shares</b></td>
        <td><TransferDocVarField field-key="total_shares_transferred" placeholder="Total" /></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
.trf-tbl th { font-size: 11px; text-align: center; }
.trf-tbl td { font-size: 11.5px; }
</style>
